import React, { useState, useEffect } from "react";
import Footer1 from "../navbar/Footer1";
import "./Team.css";

const Team = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await fetch(
          "https://vogelkoparchitects.com/api/api/teams/"
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTeamMembers(data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching team members:", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);

  return (
    <div className="team-page">
      {/* Hero Banner */}
      <div
        className="team-hero"
        style={{ backgroundImage: "url(/assets/img/Bannerimages/TEAM.jpg)" }}
      >
        <div className="team-hero-overlay"></div>
        <div className="team-hero-content">
          <h1 className="team-hero-title">Team</h1>
        </div>
      </div>
      
      {/* About Us Section */}
      <section className="team-about-section">
        <div className="container">
          <div className="team-about-content">
            <h2 className="team-about-heading">ABOUT US</h2>
            <p className="team-about-text">
              Vogelkop architects is a collaborative studio practice led by Bhuvanesh and Hari Haran, with assistance from a group of young professionals. We employ an integrated design methodology that encompasses interior design, landscape architecture, and architectural design. Through extensive studies, explorations, study models, and sketches, the design process aims to reconcile the multiple paradoxes between customer wants and affordability, site conditions and programming dictates.
            </p>
          </div>
        </div>
      </section>

      {/* Team Section with Alternating Layout */}
      <section className="team-section">
        <div className="container">
          {loading ? (
            <div className="team-loader">
              <div className="loader"></div>
              <p>Loading team members...</p>
            </div>
          ) : error ? (
            <div className="team-error">
              <p>Error loading team members: {error}</p>
            </div>
          ) : (
            <div className="team-members">
              {teamMembers.map((member, index) => (
                <div 
                  key={member.id} 
                  className={`team-member ${index % 2 === 0 ? 'image-left' : 'image-right'}`}
                >
                  <div className="team-member-image">
                    <img
                      src={member.image}
                      alt={member.name}
                      onError={(e) => {
                        e.target.src = "/placeholder-image.jpg";
                      }}
                    />
                    {/* Social Links Overlay */}
                    <div className="team-social-overlay">
                      {member.twitter_link && (
                        <a href={member.twitter_link} target="_blank" rel="noopener noreferrer" className="social-link">
                          <i className="bi bi-twitter-x"></i>
                        </a>
                      )}
                      {member.instagram_link && (
                        <a href={member.instagram_link} target="_blank" rel="noopener noreferrer" className="social-link">
                          <i className="bi bi-instagram"></i>
                        </a>
                      )}
                      {member.linkedin_link && (
                        <a href={member.linkedin_link} target="_blank" rel="noopener noreferrer" className="social-link">
                          <i className="bi bi-linkedin"></i>
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="team-member-info">
                    <h2 className="team-member-name">{member.name}</h2>
                    <h3 className="team-member-role">{member.role}</h3>
                    {member.description && (
                      <p className="team-member-description">{member.description}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer1 />
    </div>
  );
};

export default Team;